module.exports = __webpack_public_path__ + "img/like.8c92e998.svg";